import { Cleaner } from './Cleaner';
export class WordingCleaner extends Cleaner {
    constructor(parent) {
        super(parent);
    }
    get wordTask() {
        return this.parent.wordTask;
    }
    get rawString() {
        return this.parent.wordingString;
    }
}
